export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <img
      className="moyu-mark"
      src="/brand/island-2026/mark.webp"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
    />
  );
}

export function IslandMascot({ className = '' }: { className?: string }) {
  return (
    <img
      className={`island-mascot ${className}`}
      src="/brand/moyu-island.svg"
      width={240}
      height={170}
      alt=""
      aria-hidden="true"
    />
  );
}

export function BrandLogo() {
  return (
    <span className="moyu-brand-logo" role="img" aria-label="摸鱼岛 MOYU ISLAND">
      <img src="/brand/island-2026/logo.webp" width={180} height={60} alt="" aria-hidden="true" />
      <img
        className="moyu-brand-wordmark-light"
        src="/brand/island-2026/logo.webp"
        width={180}
        height={60}
        alt=""
        aria-hidden="true"
      />
    </span>
  );
}
